import React, { useState } from 'react';
import { readTodayLog, clearTodayLog } from '../../services/geminiAttemptLog';
import { describeGeminiStatusShort } from '../../utils/aiPrompts';

const badgeTone = (key) =>
    key === '200'
        ? 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-200'
        : 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-200';

const formatTime = (iso) => {
    if (!iso) return '';
    try {
        return new Date(iso).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
    } catch (e) {
        return '';
    }
};

export const GeminiAttemptLog = () => {
    const [log, setLog] = useState(() => readTodayLog());

    const gesamt = log.models.reduce((sum, m) => sum + m.attempts, 0);

    return (
        <div>
            <div className="flex items-baseline justify-between mb-2">
                <h3 className="text-lg font-semibold text-slate-800 dark:text-slate-200">
                    Heute versucht
                </h3>
                <div className="flex items-center gap-3">
                    <button
                        type="button"
                        onClick={() => setLog(readTodayLog())}
                        className="text-xs text-slate-500 hover:text-slate-800 dark:text-slate-400 dark:hover:text-slate-200"
                    >
                        Aktualisieren
                    </button>
                    {log.models.length > 0 && (
                        <button
                            type="button"
                            onClick={() => {
                                clearTodayLog();
                                setLog(readTodayLog());
                            }}
                            className="text-xs text-slate-500 hover:text-red-600 dark:text-slate-400 dark:hover:text-red-400"
                        >
                            Zurücksetzen
                        </button>
                    )}
                </div>
            </div>
            <p className="text-sm text-slate-500 dark:text-slate-400 mb-4">
                Bei einem Fehler wird automatisch das nächste Modell probiert, keines wird ausgelassen.
            </p>

            {log.models.length === 0 ? (
                <p className="text-sm text-slate-500 dark:text-slate-400 italic">
                    Heute noch kein KI-Aufruf.
                </p>
            ) : (
                <>
                    <div className="overflow-x-auto">
                        <table className="w-full text-sm">
                            <thead>
                                <tr className="text-left text-xs uppercase tracking-wide text-slate-500 dark:text-slate-400 border-b border-slate-200 dark:border-slate-700">
                                    <th className="py-2 pr-4 font-medium">Modell</th>
                                    <th className="py-2 pr-4 font-medium text-right">Versuche</th>
                                    <th className="py-2 pr-4 font-medium text-right">Davon OK</th>
                                    <th className="py-2 pr-4 font-medium">Ergebnisse</th>
                                    <th className="py-2 font-medium text-right">Zuletzt</th>
                                </tr>
                            </thead>
                            <tbody>
                                {log.models.map((m) => (
                                    <tr key={m.model} className="border-b border-slate-100 dark:border-slate-800">
                                        <td className="py-2 pr-4 font-mono text-xs text-slate-800 dark:text-slate-200">
                                            {m.model}
                                        </td>
                                        <td className="py-2 pr-4 text-right tabular-nums text-slate-700 dark:text-slate-300">
                                            {m.attempts}
                                        </td>
                                        <td className="py-2 pr-4 text-right tabular-nums text-slate-700 dark:text-slate-300">
                                            {m.ok}
                                        </td>
                                        <td className="py-2 pr-4">
                                            <div className="flex flex-wrap gap-1">
                                                {Object.entries(m.byStatus).map(([key, count]) => (
                                                    <span
                                                        key={key}
                                                        className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs ${badgeTone(key)}`}
                                                        title={`${key} — ${describeGeminiStatusShort(key)}`}
                                                    >
                                                        {describeGeminiStatusShort(key)}
                                                        {count > 1 && <span className="opacity-70">×{count}</span>}
                                                    </span>
                                                ))}
                                            </div>
                                        </td>
                                        <td className="py-2 text-right tabular-nums text-xs text-slate-500 dark:text-slate-400">
                                            {formatTime(m.lastAt)}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <p className="text-xs text-slate-500 dark:text-slate-400 mt-3">
                        {gesamt} {gesamt === 1 ? 'Aufruf' : 'Aufrufe'} am {log.day}, gespeichert nur in diesem Browser.
                    </p>
                </>
            )}
        </div>
    );
};
